import { Navigate, createFileRoute } from "@tanstack/react-router";
import { AddBot } from "~/components/add-bot";
import { ServerError } from "~/components/server-error";
import { ServerNotFound } from "~/components/server-not-found";
import { LoadingSpinner } from "~/routes/__root";
import { GuildDashboard } from "./-guild-dashboard";
import { useGuildRouteData } from "./-use-guild-route-data";

export const Route = createFileRoute("/_authed/dashboard/$guildId/")({
  component: RouteComponent,
});

function RouteComponent() {
  const { guildId } = Route.useParams();
  const { guild, isLoadingGuild, guildError, isSubscriptionOwner } =
    useGuildRouteData(guildId);

  if (!guild && isLoadingGuild) {
    return <LoadingSpinner />;
  }

  if (guildError) {
    return <ServerError error={guildError} />;
  }

  if (!guild) {
    return <ServerNotFound />;
  }

  if (!guild?.isBotInGuild) {
    return <AddBot guild={guild} />;
  }

  if (!guild?.subscription) {
    return (
      <Navigate
        to={`/dashboard/$guildId/subscribe`}
        params={{ guildId }}
        state={(prev) => ({
          ...prev,
          guildPreview: guild,
        })}
      />
    );
  }

  return (
    <GuildDashboard guild={guild} isSubscriptionOwner={isSubscriptionOwner} />
  );
}
